import { render, staticRenderFns } from "./AppNews.vue?vue&type=template&id=ca7f00d4&scoped=true&"
import script from "./AppNews.vue?vue&type=script&lang=js&"
export * from "./AppNews.vue?vue&type=script&lang=js&"
import style0 from "./AppNews.vue?vue&type=style&index=0&id=ca7f00d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7f00d4",
  null
  
)

export default component.exports